import React, { useState, useEffect } from "react";
import styles from "./Category.module.css";
import { Row, Col, Card, Tooltip, Space, Spin, Select, message } from "antd";

import { FetchTabSearch } from "./FetTab";
import { fetchTrend } from "../../../../api";
const { Option } = Select;

const Category = () => {
  const [rel, setRel] = useState(null);
  const [usrRel, setUsrRel] = useState("");
  const [load, setLoad] = useState(true);
  const [submit, setSubmit] = useState(true);
  const [selRel, setSelRel] = useState(rel);

  useEffect(() => {
    if (!rel) {
      fetchData();
    }
    console.log("effect");
  }, [rel]);

  const fetchData = async () => {
    setLoad(true);
    const relVersion = await fetchTrend("fetConVersion");
    setRel(relVersion["curVersion"]);
    setSelRel(relVersion["curVersion"]);
    setUsrRel("snapshot_v" + relVersion["curVersion"] + "_0_0");
    setLoad(false);
    console.log(relVersion["curVersion"]);
  };

  function onChange(value) {
    message.info(`Release snapshot_v${value}_0_0`);
    setUsrRel("snapshot_v" + value + "_0_0");
    setSelRel(value);
    setSubmit(!submit);
  }

  return (
    <div>
      {/* date range filter */}
      <Row type="flex" style={{ margin: "5px", padding: "1px" }}>
        <Col className="gutter-row" span={1}></Col>
        <Col className="gutter-row" span={14}>
          <Card
            bordered={false}
            style={{ height: 70, margin: "1px", padding: "1px" }}
          >
            <Space>
              {load ? (
                <div>
                  <Spin size="small" />
                </div>
              ) : (
                <Select
                  showSearch
                  // defaultValue={usrRel}
                  style={{ width: 400 }}
                  placeholder="Select Release"
                  optionFilterProp="children"
                  onChange={onChange}
                  value={selRel}
                >
                  <Option value={rel}>Release {rel}</Option>
                  <Option value={rel - 1}>Release {rel - 1}</Option>
                  <Option value={rel - 2}>Release {rel - 2}</Option>
                  <Option value={rel - 3}>Release {rel - 3}</Option>
                  <Option value={rel - 4}>Release {rel - 4}</Option>
                </Select>
              )}
            </Space>
          </Card>
        </Col>
      </Row>

      {/* Card */}
      <Row style={{ margin: "5px", padding: "1px" }}>
        {load ? (
          <div className={styles.spinner}>{/* <Spin size="small" /> */}</div>
        ) : (
          <FetchTabSearch submit={submit} rel={rel} usrRel={usrRel} />
        )}
        {/* </Col> */}
      </Row>
    </div>
  );
};

export default Category;
